define('glu/grid/paginate/pager',['require','../../layout','../../locale','../../util','../../screenManager','hbs!./paginateSimple.hbs','hbs!./paginateAdvanced.hbs','hbs!./paginateIntermediate.hbs','./paginationControls','./viewingDetails','./pageSizeControls','../../templateHelpers'],function(require) {
    'use strict';

    var Layout = require('../../layout'),
        locale = require('../../locale'),
        util = require('../../util'),
        screenManager = require('../../screenManager'),
        simpleTpl = require('hbs!./paginateSimple.hbs'),
        advancedTpl = require('hbs!./paginateAdvanced.hbs'),
        intermediateTpl = require('hbs!./paginateIntermediate.hbs'),
        PaginationControls = require('./paginationControls'),
        ViewingDetails = require('./viewingDetails'),
        PageSizeControls = require('./pageSizeControls'),
        templateHelpers = require('../../templateHelpers');

    return Layout.extend({
        className: 'pager',

        events: {
            'click .prev-page': 'handlePrevClick',
            'click .next-page': 'handleNextClick',
            'click .page-item': 'handlePageItemClick',
            'click .first-page': 'handleFirstPageClick',
            'click .last-page': 'handleLastPageClick',
            'submit': 'handleSubmit'
        },

        regions: {
            viewingDetails: '.js-region-grid-viewing-details',
            pageSizeControls: '.js-region-grid-page-size-controls',
            paginationControls: '.js-region-grid-pagination-controls'
        },

        appEvents: function() {
            if (util.isNumber(this.options.currentPage)) {
                return {
                    'grid:filter': function() {
                        // If the filtered data does not have enough records to populate the user's current page, reset their page view to 0
                        if (!this.serverSidePagination && this.getRecordCount() < ((this.currentPage - 1) * this.pageSize) + 1) {
                            this.handleFirstPageClick();
                        }
                    }
                };
            }

            return {};
        },

        initialize: function(options) {
            // need to add this because this.options is used in some of the methods.
            options = options || {};
            this.options = options;

            this.type = this.options.type || 'advanced';
            this.pageSize = this.options.pageSize || 5;
            this.currentPage = this.options.currentPage || 1;
            this.pageSizeValues = this.options.pageSizeValues || [3, 5, 10, 25, 50, 100, 250];
            this.outputCollection = this.options.outputCollection;
            this.inputCollection = this.options.inputCollection;
            this.paginateMethod = this.options.paginateMethod;
            this.stateModel = this.options.stateModel;
            this.total = this.inputCollection.length > 0 ? Math.ceil(this.inputCollection.length / this.pageSize) : 1;
            this.renderPageSizeView = util.once(this.showPageSizeControls.bind(this));

            this.saveState();

            if (typeof this.paginateMethod === 'function') {
                this.serverSidePagination = true;
            }

            this.listenTo(this.inputCollection, {
                // need to proxy this events from input collection to gridCollection.
                'add': util.debounce(this.addItem.bind(this), 0),
                'remove': util.debounce(this.removeItem.bind(this), 0),
                'reset sort': util.debounce(this.handleInputChange.bind(this), 0),
                'sync': util.debounce(util.bind(this.updateChildViews, this), 0)
            });
        },

        addItem: function(model) {
            if (this.isClosed) {
                return;
            }
            this.updatePager();
            this.updateChildViews();
            this.outputCollection.add(model);
        },

        removeItem: function(model) {
            if (this.isClosed) {
                return;
            }
            this.updatePager();
            this.updateChildViews();
            this.outputCollection.remove(model);
        },

        updatePager: function() {
            if (this.isClosed) {
                return;
            }
            this.calcTotal();
            this.boundCurrentPage();
            this.buildPages();
        },

        slice: function() {
            var start = this.getCurrentPage() > 1 ? (this.getCurrentPage() - 1) * this.pageSize : 0,
                end = start + (this.pageSize),
                result = this.inputCollection.slice(start, end);

            this.updatePager();

            if (this.serverSidePagination) {
                return this.outputCollection.reset(this.inputCollection.models);
            }

            this.outputCollection.reset(result);
        },

        onRender: function() {
            this.updateChildViews();
            // if SM is not rendered yet it can trigger an event
            this.listenToOnce(screenManager, 'change', this.updatePagerView, this);
        },

        updateChildViews: function() {
            if (this.isClosed) {
                return;
            }

            this.delegateEvents();
            this.showViewingDetails();
            this.renderPageSizeView();
            this.showPaginationControls();
        },

        showPageSizeControls: function() {
            if (this.type !== 'advanced') {
                return;
            }

            this.pageSizeControls.show(new PageSizeControls({
                data: this.serializeData(),
                pager: this
            }));
        },

        showPaginationControls: function() {
            if (this.type !== 'advanced') {
                return;
            }

            this.paginationControls.show(new PaginationControls({
                data: this.serializeData(),
                pager: this
            }));
        },

        showViewingDetails: function() {
            if (this.type !== 'advanced') {
                return;
            }

            this.viewingDetails.show(new ViewingDetails({
                data: this.serializeData()
            }));
        },

        updatePagerView: function() {
            this.renderPageSizeView = util.once(this.showPageSizeControls.bind(this));
            this.render();
        },

        paginate: function() {
            // Broadcast a pagination event.
            this.appBus.trigger('grid:paginate', this);

            this.saveState();

            if (this.serverSidePagination) {
                // inputChange method will be called once the collection is updated
                return this.paginateMethod(this.currentPage, this.pageSize);
            }

            this.slice();
            this.updateChildViews();
        },

        getRecordCount: function() {
            return (typeof this.inputCollection.totalCount === 'number') ?
                this.inputCollection.totalCount :
                this.inputCollection.length;
        },

        getPageCount: function() {
            var totalCount = this.getRecordCount();

            // all 13 / page 5 = 2.6 but needs to be 3
            // includes handling of case where there are no records.
            return totalCount > 0 ? Math.ceil(totalCount / this.pageSize) : 1;
        },

        getCurrentPage: function() {
            return (typeof this.inputCollection.currentPage === 'number') ?
                this.inputCollection.currentPage :
                this.currentPage;
        },

        handleFirstPageClick: function() {
            if (this.currentPage !== 1) {
                this.currentPage = 1;
                this.paginate();
            }
        },

        handleLastPageClick: function() {
            this.currentPage = this.getPageCount();
            this.paginate();
        },

        handlePageItemClick: function(e) {
            this.currentPage = parseInt(e.target.innerHTML, 10);
            this.paginate();
        },

        handlePrevClick: function(e) {
            e.preventDefault();
            this.decrementCurrentPage();
            this.paginate();
        },

        handleNextClick: function(e) {
            e.preventDefault();
            this.incrementCurrentPage();
            this.paginate();
        },

        updatePageSizeValue: function(selectedValue) {
            var numericSelectedValue = +selectedValue,
                value = util.isNaN(numericSelectedValue) ? 1000000 : numericSelectedValue;

            if (this.pageSize === value) {
                return;
            }

            this.pageSize = value;
            this.inputCollection.recordsPerPage = value;
            // reset current page to first
            this.currentPage = 1;
            this.paginate();
        },

        handlePageSelect: function(value) {
            if (this.currentPage === value) {
                return;
            }

            this.currentPage = value;
            this.paginate();
        },

        handleInputChange: function() {
            if (this.isClosed) {
                return;
            }

            this.slice();
            this.updateChildViews();
        },

        handleSubmit: function() {
            return false;
        },

        decrementCurrentPage: function() {
            this.currentPage = this.getCurrentPage() - 1;
            if (this.currentPage < 1) {
                this.currentPage = 1;
            }
        },

        incrementCurrentPage: function() {
            this.currentPage = this.getCurrentPage() + 1;
            if (this.currentPage > this.getPageCount()) {
                this.currentPage = this.getPageCount();
            }
        },

        calcTotal: function() {
            // If we're using server-side pagination, there is currently no way of knowing the total
            if (this.serverSidePagination) {
                this.total = this.currentPage;
                return;
            }

            // includes handling of case where there are no records.
            this.total = this.inputCollection.length > 0 ? Math.ceil(this.inputCollection.length / this.pageSize) : 1;
        },

        boundCurrentPage: function() {
            if (this.currentPage >= this.total) {
                this.currentPage = this.total;
            } else if (this.currentPage < 0) {
                this.currentPage = 1;
            }
        },

        buildPages: function() {
            this.pages = util.range(1, this.getPageCount() + 1);
        },

        getTemplate: function() {
            // override template settings for small screens
            if (screenManager.isSmall() || screenManager.isExtraSmall()) {
                return simpleTpl;
            }

            switch (this.type) {
                case 'simple':
                    return simpleTpl;
                case 'intermediate':
                    return intermediateTpl;
                case 'advanced':
                default:
                    this.type = 'advanced';
                    return advancedTpl;
            }
        },

        serializeData: function() {
            var start = this.getCurrentPage() > 0 ? ((this.getCurrentPage() - 1) * this.pageSize) + 1 : 1;
            var totalCount = this.getRecordCount(),
                end = start + (this.pageSize - 1);

            return {
                'recordRangeStart': totalCount === 0 ? 0 : start,
                'recordRangeEnd': totalCount - end > 0 ? end : totalCount,
                'totalRecords': totalCount,
                'pageSize': this.pageSize,
                'currentPage': this.getCurrentPage(),
                'currentPageNumber': this.getCurrentPage(),
                'pageSizeList': this.pageSizeValues,
                'totalPages': this.getPageCount(),
                'pages': this.pages,
                'resultsName': this.options.resultsName || locale.get('records')
            };
        },

        saveState: function() {
            if (!this.stateModel) {
                return;
            }

            this.stateModel.set({
                'currentPage': this.currentPage,
                'pageSize': this.pageSize
            });
        }
    });
});

